import React, { useState, useMemo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Image } from 'react-bootstrap'
import csc from 'country-state-city'
import { userProfileUpdateAsync } from '../../../Auth/_redux'
import ethereum_address from 'ethereum-address'
import { CheckWalletAddress } from '../../../Auth/_redux'
import { AuthActions } from '../../../Auth/_redux'
import { showSuccessSnackbar } from '../../../Snackbar/snackbar.action'
import axios from 'axios'
import { defaultSnackbarTimeout } from '../../../../../utils'

const phoneRegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
const FILE_SIZE = 5242880
const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png']

const BasicDetailsTab = ({ user, isLoading }) => {
  const [file, setFile] = useState({ file: null, url: '' })
  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState([])
  const [walletaddress, setwalletaddress] = useState(user.walletAddress || '')
  const [walletAddressValidity, setWalletAddressValidity] = useState(true)
  const [fileInfoMsg, setFileInfoMsg] = useState({
    show: false,
    message: null,
  })
  const [respCode, setRespCode] = useState()

  const dispatch = useDispatch()

  const initialValues = {
    emailId: user.emailId || '',
    contactNumber: user.contactNumber || '',
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    country: user.country || '',
    state: user.state || '',
    city: user.city || '',
    address: user.address || '',
    walletAddress: user.walletAddress || '',
  }

  let allCountriesList = useMemo(() => csc.getAllCountries())

  useEffect(() => {
    if (user.state && user.country) {
      let stateList = csc.getStatesOfCountry(user.country)
      setStateList(stateList)
    }
    if (user.city && user.country && user.state) {
      let cityList = csc.getCitiesOfState(user.country, user.state)
      setCityList(cityList)
    }
  }, [user])

  const basicInfoSchema = Yup.object().shape({
    // emailId: Yup.string().trim()
    //     .email("Wrong email format")
    //     .min(3, "Minimum 3 characters")
    //     .max(50, "Maximum 50 characters")
    //     .when('email', {
    //         is: (email) => email !== "",
    //         then: Yup.string()
    //            .required("Please enter valid email address")
    //     }),
    // contactNumber: Yup.string().trim()
    //     .when('contactNumber', {
    //         is: (contactNumber) => contactNumber !== "",
    //         then: Yup.string()
    //             .matches(phoneRegExp, "Contact Number is not valid")
    //     }),
    firstName: Yup.string().trim().required('First Name is Required'),
    lastName: Yup.string().trim().required('Last Name is Required'),
    state: Yup.string().trim().required('State is Required'),
    city: Yup.string().trim().required('City is Required'),
    address: Yup.string().trim().required('Address is Required'),
    walletAddress: Yup.string().trim().required('wallet Address is Required'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: basicInfoSchema,
    onSubmit: (values) => {
      console.log(values)
      console.log(file.file)
      let data = null
      if (file && file.file) {
        data = new FormData()
        data.append('img', file.file)
      }
      dispatch(userProfileUpdateAsync(values, user._id, data))
    },
  })

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return 'is-invalid'
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return 'is-valid'
    }

    return ''
  }

  const onCountryChange = (e) => {
    let country = e.target.value
    let stateList = csc.getStatesOfCountry(country)
    setStateList(stateList)
    formik.handleChange(e)
  }

  const onStateChange = (e) => {
    let state = e.target.value
    let cityList = csc.getCitiesOfState(formik.values.country, state)
    setCityList(cityList)
    formik.handleChange(e)
  }

  const uploadImage = (e) => {
    const file = e.target.files[0]

    // file Validation
    if (file.size > FILE_SIZE) {
      setFileInfoMsg({
        show: true,
        message: 'File size must not be higher than 5MB.',
      })
      return dispatch(
        showSuccessSnackbar('error', 'File size is too big.', 3000),
      )
    }

    if (!SUPPORTED_FORMATS.some((type) => file.type === type)) {
      setFileInfoMsg({
        show: true,
        message: 'Supported file types are: JPEG, JPG, PNG.',
      })
      return dispatch(
        showSuccessSnackbar('error', 'Unsupported file type.', 3000),
      )
    }

    setFileInfoMsg({ show: false, message: null })

    setFile({
      url: URL.createObjectURL(file),
      file,
    })
  }

  const handlewalletaddress = async (e) => {
    const walletAddress = e.target.value
    try {
      if (ethereum_address.isChecksumAddress(walletAddress)) {
        setWalletAddressValidity(true)

        let details = {
          emailId: '',
          walletAddress: '',
        }
        details.walletAddress = e.target.value
        details.emailId = user.emailId
        dispatch(CheckWalletAddress(details))
      } else {
        setWalletAddressValidity(false)
      }
    } catch (e) {
      setWalletAddressValidity(false)
    } finally {
      setwalletaddress(walletAddress)
    }
    console.log(initialValues.walletAddress)

    formik.handleChange(e)
  }

  return (
    <div className="tblmrgn mt-0 lwpddng cstm_pddng">
      <div className="row justify-content-center">
        <div className="col-xl-6 col-md-6-as">
          <form
            className="form def_form frmwtpddng"
            onSubmit={formik.handleSubmit}
          >
            <div className="row">
              <div className="col-md-12 text-center mb-4">
                <div className="pro_img">
                  <Image
                    src={user.profilePicture}
                    alt="icon"
                    title="icon"
                    className=""
                    fluid
                  />
                  <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={uploadImage}
                  />
                  <div className="edt_img_btn">
                    <span className="material-icons">edit</span>EDIT
                  </div>
                  {file.url && (
                    <div className="enIconUploaded w-100">
                      <button
                        type="button"
                        className="enCloseButton"
                        onClick={() => setFile({ file: null, url: '' })}
                      >
                        Remove
                      </button>
                      <Image
                        src={file.url}
                        alt="icon"
                        title="icon"
                        className=""
                        fluid
                      />
                    </div>
                  )}
                </div>
                <div className="mt-3 text-danger">
                  {fileInfoMsg.show && <p>{fileInfoMsg.message}</p>}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label">First Name</label>
                  <input
                    placeholder="First Name"
                    type="text"
                    className={`form-control ${getInputClasses(
                      'firstName',
                    )} password-valid`}
                    name="firstName"
                    {...formik.getFieldProps('firstName')}
                  />
                  {formik.touched.firstName && formik.errors.firstName ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.firstName}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label">Last Name</label>
                  <input
                    placeholder="Last Name"
                    type="text"
                    className={`form-control ${getInputClasses(
                      'lastName',
                    )} password-valid`}
                    name="lastName"
                    {...formik.getFieldProps('lastName')}
                  />
                  {formik.touched.lastName && formik.errors.lastName ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.lastName}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="form-label">Phone</label>
                  <input
                    placeholder="+1 234567890"
                    type="text"
                    className={`form-control ${getInputClasses(
                      'contactNumber',
                    )} password-valid`}
                    name="contactNumber"
                    {...formik.getFieldProps('contactNumber')}
                    disabled
                  />
                  {formik.touched.contactNumber &&
                  formik.errors.contactNumber ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.contactNumber}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="form-label">Email</label>
                  <input
                    placeholder="username@company.com"
                    type="email"
                    className={`form-control ${getInputClasses(
                      'emailId',
                    )} password-valid`}
                    name="emailId"
                    {...formik.getFieldProps('emailId')}
                    disabled
                  />
                  {formik.touched.emailId && formik.errors.emailId ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.emailId}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="form-label">Country</label>
                  <select
                    className={`form-control wtblcar`}
                    name="country"
                    onChange={onCountryChange}
                    value={formik.values.country}
                    onBlur={formik.handleBlur}
                  >
                    <option value="">Select</option>
                    {allCountriesList.map((country) => (
                      <option value={country.isoCode} key={country.isoCode}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                  {formik.touched.country && formik.errors.country ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.country}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="form-label">State</label>
                  <select
                    className={`form-control wtblcar`}
                    name="state"
                    onChange={onStateChange}
                    value={formik.values.state}
                    onBlur={formik.handleBlur}
                  >
                    <option>Select</option>
                    {stateList.map((state) => (
                      <option value={state.isoCode} key={state.isoCode}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                  {formik.touched.state && formik.errors.state ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors.state}</div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="form-label">City</label>
                  <select
                    className={`form-control wtblcar`}
                    name="city"
                    {...formik.getFieldProps('city')}
                  >
                    <option>Select</option>
                    {cityList.map((city, i) => (
                      <option value={city.name} key={i}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                  {formik.touched.city && formik.errors.city ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors.city}</div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="form-label">Address</label>
                  <input
                    placeholder="1245, lorem ipsum, areaname"
                    type="text"
                    className={`form-control ${getInputClasses(
                      'address',
                    )} password-valid`}
                    name="address"
                    {...formik.getFieldProps('address')}
                  />
                  {formik.touched.address && formik.errors.address ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.address}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label className="form-label pr-2">Wallet Address</label>
                  {walletAddressValidity ? (
                    <i className="fas fa-check-circle green"></i>
                  ) : (
                    <i className="fas fa-times-circle"></i>
                  )}
                  <input
                    placeholder="Enter an Ethereum wallet address"
                    type="text"
                    className={`form-control ${getInputClasses(
                      'walletAddress',
                    )} password-valid`}
                    name="walletAddress"
                    {...formik.getFieldProps('walletAddress')}
                    onChange={handlewalletaddress}
                    value={walletaddress}
                  />
                  {(formik.touched.walletAddress &&
                    walletAddressValidity == false) ||
                  (formik.touched.walletAddress &&
                    formik.errors.walletAddress) ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.walletAddress}
                      </div>
                    </div>
                  ) : null}

                  <div className="form-text text-muted">
                    NOTE: The Ethereum wallet address used here must be unique
                    and must not be used by any other user.
                  </div>
                  <div className="text-muted form-text mt-2">
                    Don't have an Ethereum wallet?{' '}
                    <a href="https://metamask.io" target="_blank">
                      Click here
                    </a>{' '}
                    to set one up.
                  </div>
                </div>
              </div>
            </div>

            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0 mt-4">
              <button
                disabled={isLoading}
                type="submit"
                className="btn btn-def btn-defv4"
              >
                <span>Update</span>
                {isLoading && (
                  <span className="ml-3 spinner spinner-white"></span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default BasicDetailsTab
